export enum TelephonyDataEventObject {
  // from contact
  CONTACT_CARD_CALL = 'contact_card_call',

  // call back from message
  CALL_BACK = 'call_back',

  // banner
  INCOMING_CALL = 'incoming_call',
  LOGGED_OUT = 'logged_out',

  // from compose dropdown
  NEW_CONVERSATION_DROPDOWN_CALL = 'new_conversation_dropdown_call',

  // p4 contacts
  CONTACT_DETAILS_CALL = 'contact_details_call',

  // generic call actions
  ACTIONS = 'actions',

  // p3 message viewer
  VOICE_ACTIONS = 'voice_actions',

  // dialer
  VIEW = 'view',
  CALL = 'call',
  SELECT_CHANNEL = 'select_channel',
  AUTHENTICATION = 'authentication',
  CONTACTS = 'contacts',
  KEYPAD = 'keypad',
}
